module.exports = __webpack_public_path__ + "static/media/yakuza-cover-video.e86e70c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-cover-video.jpg
// module id = 595
// module chunks = 0